<button [id]="componentId + '-btn'" [attr.data-cy]="componentId + '-btn'" (click)="emitClick($event)"
  class="border border-blue-100 w-full rounded px-9 py-2 text-sm hover:bg-blue-100 hover:text-white"
  [disabled]="disableBtn" [ngClass]="{'text-white-900 !bg-white-disabled !border-0' : disableBtn}">
  {{btnText}} <ng-content></ng-content>
</button>
